import { SVGProps, useId } from 'react';

function RefreshIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  const maskId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <mask
        id={maskId}
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#D9D9D9" d="M0 0h24v24H0z" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          fill="currentColor"
          d="M12.047 19c-2.03 0-3.758-.728-5.183-2.185-1.426-1.457-2.138-3.228-2.138-5.315v-.756l-1.737 1.79L2 11.516l3.43-3.536 3.43 3.536-.99 1.02-1.736-1.79v.755c0 1.681.573 3.11 1.721 4.285 1.149 1.176 2.546 1.763 4.192 1.763.389 0 .777-.043 1.165-.13a5.46 5.46 0 0 0 1.136-.394l1.056 1.088a7.16 7.16 0 0 1-1.636.664 6.676 6.676 0 0 1-1.721.224Zm6.523-3.979-3.43-3.536.99-1.02 1.736 1.79V11.5c0-1.681-.573-3.11-1.721-4.285-1.149-1.176-2.546-1.763-4.192-1.763-.389 0-.777.043-1.165.13a5.461 5.461 0 0 0-1.136.394L8.596 4.888a7.164 7.164 0 0 1 1.636-.664A6.676 6.676 0 0 1 11.953 4c2.03 0 3.758.728 5.183 2.185 1.426 1.457 2.138 3.228 2.138 5.315v.756l1.737-1.79.989 1.019-3.43 3.536Z"
        />
      </g>
    </svg>
  );
}

export default RefreshIcon;
